import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal } from '@azure/msal-react';
import { Navbar, Button } from 'react-bootstrap';
import { loginRequest } from '../authConfig';

export const NavigationBar = () => {
    const { instance } = useMsal();

    const handleLoginRedirect = () => {
        instance.loginRedirect(loginRequest).catch((error) => console.log(error));
    };

    const handleRegisterRedirect = () => {
        // 'create' prompt attempts to land user on the account creation page (if supported by the identity provider)
        instance.loginRedirect({
            ...loginRequest,
            prompt: 'create'
        }).catch((error) => console.log(error));
    };

    const handleLogoutRedirect = () => {
        // Explicitly pass the active account to ensure it's logged out
        const activeAccount = instance.getActiveAccount();
        instance.logoutRedirect({
            account: activeAccount,
            postLogoutRedirectUri: "/"
        }).catch((error) => console.log(error));
    };


    return (
        <>
            <Navbar bg="light" variant="light" className="navbarStyle" style={{ position: 'relative', boxShadow: '0 4px 12px rgba(0,0,0,0.1)', display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '0.75rem 2rem' }}>
                {/* Left side: MKS Logo and PAIRX Logo */}
                <div style={{ flex: '0 0 auto', display: 'flex', alignItems: 'center', gap: '1.5rem' }}>
                    <img
                        src="/mks-logo.jpg"
                        alt="MKS Atotech Logo"
                        style={{ height: '100px', width: '120px' }}
                    />
                    <img
                        src="/pairx-logo.jpg"
                        alt="PAIRX Logo"
                        style={{ height: '60px', width: 'auto' }}
                    />
                </div>

                {/* Center Home link */}
                <div style={{ position: 'absolute', left: '50%', transform: 'translateX(-50%)' }}>
                    <a className="nav-link" href="/" style={{ fontWeight: '800', fontSize: '2.4rem', background: 'linear-gradient(135deg, #0f172a 0%, #1e40af 35%, #2563eb 50%, #7c3aed 100%)', backgroundClip: 'text', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', textDecoration: 'none', letterSpacing: '-0.03em', transition: 'all 0.3s ease' }}>
                        AI/ML Modelling
                    </a>
                </div>

                {/* Right side: Auth buttons and Register */}
                <div style={{ flex: '0 0 auto', display: 'flex', alignItems: 'center', gap: '1rem' }}>
                    <div>
                        <AuthenticatedTemplate>
                            <Button variant="outline-primary" onClick={handleLogoutRedirect} size="lg" style={{ fontSize: '1.1rem', padding: '0.75rem 1.8rem', fontWeight: '600' }}>
                                Sign out
                            </Button>
                        </AuthenticatedTemplate>
                        <UnauthenticatedTemplate>
                            <div style={{ display: 'flex', gap: '1rem' }}>
                                <Button onClick={handleLoginRedirect} variant="primary" size="lg" style={{ fontSize: '1.1rem', padding: '0.75rem 1.8rem', fontWeight: '600' }}>Sign in</Button>
                                <Button onClick={handleRegisterRedirect} variant="outline-dark" size="lg" style={{ fontSize: '1.1rem', padding: '0.75rem 1.8rem', fontWeight: '600' }}>
                                    Register
                                </Button>
                            </div>
                        </UnauthenticatedTemplate>
                    </div>
                </div>
            </Navbar>
        </>
    );
};
